import authService from '../../services/authService';
import userService from '../../services/userLocalStorageService';
import { setErrorMessage } from './ui';

// ACTIONS
const LOGIN = 'LOGIN';
const LOGGING_IN = 'LOGGING_IN';
const LOGIN_ERROR = 'LOGIN_ERROR';
const REFRESHING_TOKEN = 'REFRESH_TOKEN';
const LOGOUT = 'LOGOUT';
const SET_USER = 'SET_USER';
const SET_USER_LANGUAGE = 'SET_USER_LANGUAGE';
const SET_USER_DARK_MODE = 'SET_USER_DARK_MODE';

const initialState = {
    loggedIn: false,
    loggingIn: false,
    refreshing: false,
    loginFailed: false,
    preferedLanguage: 'sv-se',
    darkMode: false,
};

// REDUCER
const reducer = (state = initialState, action) => {
    switch (action.type) {
    case LOGIN: {
        return Object.assign({}, state, { loggedIn: true });
    }
    case LOGGING_IN: {
        return Object.assign({}, state, { loggingIn: action.value });
    }
    case LOGIN_ERROR: {
        return Object.assign({}, state, { loggedIn: false, loggingIn: false, loginFailed: true });
    }
    case REFRESHING_TOKEN: {
        return Object.assign({}, state, { refreshing: action.value });
    }
    case LOGOUT: {
        return Object.assign({}, state, { loggedIn: false });
    }
    case SET_USER: {
        return Object.assign({}, state, { user: action.value });
    }
    case SET_USER_LANGUAGE: {
        return Object.assign({}, state, { preferedLanguage: action.value });
    }
    case SET_USER_DARK_MODE: {
        return Object.assign({}, state, { darkMode: action.value });
    }
    default:
        return state;
    }
};

// ACTION CREATORS
const internalLogin = () => ({
    type: LOGIN,
});

const internalLoggingIn = loggingIn => ({
    type: LOGGING_IN,
    value: loggingIn,
});

const internalRefreshingToken = refreshing => ({
    type: REFRESHING_TOKEN,
    value: refreshing,
});

const logoutInternal = () => ({
    type: LOGOUT,
});

const logInError = () => ({
    type: LOGIN_ERROR,
});

const internalSetUser = user => ({
    type: SET_USER,
    value: user,
});

const internalSetUserLanguage = lang => ({
    type: SET_USER_LANGUAGE,
    value: lang,
});

const internalSetUserDarkMode = dark => ({
    type: SET_USER_DARK_MODE,
    value: dark,
});

// THUNK
const refreshToken = () => (dispatch) => {
    const token = JSON.parse(localStorage.getItem('token'));

    if (token) {
        dispatch(internalRefreshingToken(true));
        authService.refresh()
            .then((userData) => {
                dispatch(internalSetUser(userData));
                const settings = userService.getSettings(userData.username);
                dispatch(internalSetUserDarkMode(settings.darkMode));
                dispatch(internalSetUserLanguage(settings.language));
                dispatch(internalLogin());
                dispatch(internalRefreshingToken(false));
            })
            .catch(() => {
                localStorage.removeItem('token');
                dispatch(logoutInternal());
                dispatch(internalRefreshingToken(false));
            });
    }
};

const login = () => async (dispatch) => {
    dispatch(internalLoggingIn(true));
    return authService.login()
                      .then(({ data: redirectUrl }) => window.location.replace(redirectUrl))
                      .catch(() => dispatch(logInError()));
};

const loggedIn = (token) => (dispatch) =>
    authService.loggedIn(token)
               .then(userData => {
                    dispatch(internalSetUser(userData));
                    const settings = userService.getSettings(userData.username);
                    dispatch(internalSetUserDarkMode(settings.darkMode));
                    dispatch(internalSetUserLanguage(settings.language));
                    dispatch(internalLogin());
                    dispatch(internalLoggingIn(false));
                })
                .catch(() => dispatch(logInError()));

const logout = message => (dispatch) => {
    dispatch(logoutInternal());
    localStorage.removeItem('token');
    if (message) {
        dispatch(setErrorMessage(message));
    }
};

const setUserDarkMode = darkMode => (dispatch, getState) => {
    userService.setDarkMode(getState().user.user.username, darkMode);
    dispatch(internalSetUserDarkMode(darkMode));
};

const setUserLanguage = lang => (dispatch, getState) => {
    userService.setLanguage(getState().user.user.username, lang);
    dispatch(internalSetUserLanguage(lang));
};

export {
    initialState,
    login,
    loggedIn,
    logout,
    refreshToken,
    setUserLanguage,
    setUserDarkMode,
};

export default reducer;
